import { REQUEST_RATING_NEWS, REQUEST_RATING_NEWS_FINISHED } from 'store/newsFeed/newsFeedActions';
import {
  GET_ANNOUNCEMENT,
  GET_ANNOUNCEMENT_SUCCESS,
  GET_ANNOUNCEMENT_ERROR,
} from './announcementActions';

const initialState = {
  data: {
    artifactType: '',
    id: '',
    language: '',
    leadAnalysts: [],
    locales: [],
    publicationDate: '',
    shortText: '',
    shortTitle: '',
    text: '',
    title: '',
  },
  success: false,
  isPending: false,
  shouldRefresh: false,
  ratingRequestError: false,
};

export function announcement(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case GET_ANNOUNCEMENT:
      return { ...state, isPending: true };
    case GET_ANNOUNCEMENT_SUCCESS:
      return { ...state, isPending: false, data: payload.data, success: payload.success };
    case GET_ANNOUNCEMENT_ERROR:
      return { ...state, isPending: false, success: false };
    case REQUEST_RATING_NEWS:
      return { ...state, isPending: true };
    case REQUEST_RATING_NEWS_FINISHED:
      return {
        ...state,
        isPending: false,
        shouldRefresh: !(payload && payload.error),
        ratingRequestError: !!(payload && payload.error),
      };
    default:
      return state;
  }
}
